import { Checkbox, Select } from "@mantine/core";
import { useEffect, useState } from "react";
import VariableNumberInput from "../../../GlobalComponent/VariableNumberInput";
import VariableSelectCreate from "../../../GlobalComponent/VariableSelectCreate";
import VariableSelectWrite from "../../../GlobalComponent/VariableSelectWrite";

const SCOPE_LIST = [
    {
        label: "Mail.Read",
        value: "Mail.Read"
    },
    {
        label: "IMAP.AccessAsUser.All",
        value: "https://outlook.office.com/IMAP.AccessAsUser.All"
    }
]

const TYPE_GET_ACCESS_TOKEN_LIST = [
    {
        label: "GRAPH API",
        value: "GRAPH"
    },
    {
        label: "IMAP (Read mail)",
        value: "IMAP"
    }
]

const MAIL_BOX_LIST_IMAP = [
    {
        label: "INBOX",
        value: "INBOX"
    },
    
    {
        label: "JUNK",
        value: "JUNK"
    },
    
    
]

const MAIL_BOX_LIST_GRAPH = [
    {
        label: "INBOX",
        value:"inbox"
    },
    
    {
        label: "JUNK",
        value: "junkemail"
    },
    
    
]

const defaultState = {
    client_id: '',
    auth_type: TYPE_GET_ACCESS_TOKEN_LIST[0].value,
    scope: SCOPE_LIST[0].value, // Default to GRAPH API scope
    email: '',
    refresh_token: '',
    grant_type: 'refresh_token',
    mailBox: MAIL_BOX_LIST_GRAPH[0].value, // Default to GRAPH inbox
    markMailAsRead: true,
    getLatestMail: true,
    subjectFilter: '',
    contentRegex: '',
    timeout: 30000,
    outputVariable: "",
    contentMailContains: ''
}

function ReadMailOauth2(props) {
    const [dataState, setDataState] = useState(props?.nodeData?.data?.options ?? defaultState)
    const onCheckBox = (key) => (e) => {
        setDataState({ ...dataState, [key]: e.target.checked })
    }

    const onChangeValue = (key, target) => e => {
        if (e?.type === 'change') {
            setDataState((state) => ({ ...state, [key]: target ? e.target[target] : e.target.value }))
        } else if (e?.type === 'click') {
            const newValue = e.newValue || ""
            setDataState((state) => ({ ...state, [key]: newValue }))
        } else {
            setDataState((state) => ({ ...state, [key]: e }))
        }
    }

    // Initialize scope and mailBox based on auth_type when component mounts
    useEffect(() => {
        let currentAuthType = props?.nodeData?.data?.options?.auth_type || TYPE_GET_ACCESS_TOKEN_LIST[0].value;
        let currentMailBox = props?.nodeData?.data?.options?.mailBox;
        
        // Handle backward compatibility: convert old values to new values
        if (currentAuthType === 'GRAPH API') {
            currentAuthType = 'GRAPH';
        } else if (currentAuthType === 'IMAP (Read mail)') {
            currentAuthType = 'IMAP';
        }
        
        const correctScope = currentAuthType === TYPE_GET_ACCESS_TOKEN_LIST[1].value 
            ? SCOPE_LIST[1].value 
            : SCOPE_LIST[0].value;
        
        // Set default mailBox ONLY if it doesn't exist (empty or undefined)
        if (!currentMailBox) {
            currentMailBox = currentAuthType === TYPE_GET_ACCESS_TOKEN_LIST[1].value 
                ? MAIL_BOX_LIST_IMAP[0].value  // INBOX for IMAP
                : MAIL_BOX_LIST_GRAPH[0].value; // inbox for GRAPH
        }
        
        // Update auth_type, scope, and mailBox if needed
        if (dataState.scope !== correctScope || dataState.auth_type !== currentAuthType || dataState.mailBox !== currentMailBox) {
            setDataState(prev => ({ 
                ...prev, 
                auth_type: currentAuthType,
                scope: correctScope,
                mailBox: currentMailBox
            }));
        }
    }, []); // Run only once on mount

    // Auto update scope and mailBox when auth_type changes
    useEffect(() => {
        const newScope = dataState.auth_type === TYPE_GET_ACCESS_TOKEN_LIST[1].value 
            ? SCOPE_LIST[1].value 
            : SCOPE_LIST[0].value;
        
        // Determine which mailBox list is valid for current auth_type
        const validMailBoxList = dataState.auth_type === TYPE_GET_ACCESS_TOKEN_LIST[1].value 
            ? MAIL_BOX_LIST_IMAP 
            : MAIL_BOX_LIST_GRAPH;
        
        // Check if current mailBox is valid for the new auth_type
        const isCurrentMailBoxValid = validMailBoxList.some(box => box.value === dataState.mailBox);
        
        // Only change mailBox if current value is not valid for the new auth_type
        const newMailBox = isCurrentMailBoxValid 
            ? dataState.mailBox 
            : validMailBoxList[0].value;
        
        if (dataState.scope !== newScope || dataState.mailBox !== newMailBox) {
            setDataState(prev => ({ 
                ...prev, 
                scope: newScope, 
                mailBox: newMailBox 
            }));
        }
    }, [dataState.auth_type]);

    useEffect(() => {
        props.handleSetDataBaseModal({ ...dataState })
        console.log(dataState)
    }, [props, dataState])

    return (
        <>
            <Select
                label="Auth type"
                placeholder="Pick value"
                data={TYPE_GET_ACCESS_TOKEN_LIST}
                defaultValue={TYPE_GET_ACCESS_TOKEN_LIST[0].value}
                value={dataState.auth_type}
                onChange={value => setDataState((s) => ({ ...s, auth_type: value }))}
            />
            {
                dataState.auth_type === TYPE_GET_ACCESS_TOKEN_LIST[0].value && (
                    <>
                        <VariableSelectWrite
                            placeholder="Your Client ID from Azure App Registration"
                            label="Client ID"
                            dataState={dataState.client_id}
                            handleData={onChangeValue('client_id')}
                            handleSelect={onChangeValue('client_id')}
                        />
                        <VariableSelectWrite
                            placeholder="Your refresh token from OAuth2 flow"
                            label="Refresh Token"
                            dataState={dataState.refresh_token}
                            handleData={onChangeValue('refresh_token')}
                            handleSelect={onChangeValue('refresh_token')}
                        />
                        <p style={{ fontSize: '12px'}}>Note: When the refresh token is expired, you need to get a new refresh token.</p>
                        <Select
                            placeholder="Mail box"
                            label="Mail box"
                            value={dataState.mailBox}
                            onChange={value => setDataState((s) => ({ ...s, mailBox: value }))}
                            data={MAIL_BOX_LIST_GRAPH}
                            defaultValue={MAIL_BOX_LIST_GRAPH[0].value}
                        />
                    </>
                )
            }
            {
                dataState.auth_type === TYPE_GET_ACCESS_TOKEN_LIST[1].value && (
                    <>
                        <VariableSelectWrite
                            placeholder="Your email"
                            label="Email"
                            dataState={dataState.email}
                            handleData={onChangeValue('email')}
                            handleSelect={onChangeValue('email')}
                        />
                        <VariableSelectWrite
                            placeholder="Your Client ID from Azure App Registration"
                            label="Client ID"
                            dataState={dataState.client_id}
                            handleData={onChangeValue('client_id')}
                            handleSelect={onChangeValue('client_id')}
                        />
                        <VariableSelectWrite
                            placeholder="Your refresh token from OAuth2 flow"
                            label="Refresh Token"
                            dataState={dataState.refresh_token}
                            handleData={onChangeValue('refresh_token')}
                            handleSelect={onChangeValue('refresh_token')}
                        />
                        <p style={{ fontSize: '12px'}}>Note: When the refresh token is expired, you need to get a new refresh token.</p>
                        <Select
                            placeholder="Mail box"
                            label="Mail box"
                            value={dataState.mailBox}
                            onChange={value => setDataState((s) => ({ ...s, mailBox: value }))}
                            data={MAIL_BOX_LIST_IMAP}
                            defaultValue={MAIL_BOX_LIST_IMAP[0].value}
                        />
                    </>
                )
            }
            {/* <VariableSelectWrite
                placeholder="INBOX"
                label="Mailbox"
                dataState={dataState.mailBox}
                handleData={onChangeValue('mailBox')}
                handleSelect={onChangeValue('mailBox')}
            /> */}

            <div style={{ marginTop: '20px' }}>
                <Checkbox
                    checked={dataState.markMailAsRead}
                    label="Mark mail as read"
                    onChange={onCheckBox('markMailAsRead')}
                />
                <Checkbox
                    checked={dataState.getLatestMail}
                    label="Get latest mail"
                    onChange={onCheckBox('getLatestMail')}
                />
            </div>
            {
                !dataState.getLatestMail && (
                    <VariableSelectWrite
                        placeholder="Subject"
                        label="Subject email contains"
                        dataState={dataState.subjectFilter}
                        handleData={onChangeValue('subjectFilter')}
                        handleSelect={onChangeValue('subjectFilter')}
                    />
                )
            }
            <VariableSelectWrite
                placeholder="Regex"
                label="Content mail contains"
                dataState={dataState.contentMailContains}
                handleData={onChangeValue('contentMailContains')}
                handleSelect={onChangeValue('contentMailContains')}
            />
            <VariableNumberInput
                label="Read mail timeout (milliseconds)"
                dataState={dataState.timeout}
                handleData={onChangeValue("timeout")}
                isMillisecond={true}
            />
            <VariableSelectCreate
                label="Output variable"
                placeholder="Select variable"
                value={dataState.outputVariable}
                handleChange={onChangeValue("outputVariable")}
            />
        </>
    );
}


export default ReadMailOauth2;